let my_key = {
    publicTestKey : "test_public_key_71ff268fbc224c468cdafd40ffc5f5ea",
    secretKey : "test_secret_key_2b93c8318bdc4a039febe9841f772ddd"
}

export default my_key;